/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {TaskDTO} from '../model/taskDTO';
import {TaskLiteDTO} from '../model/taskLiteDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {PageTaskLiteDTO} from '../model/pageTaskLiteDTO';
import {TaskFilterDTO} from '../model/taskFilterDTO';


@Injectable()
export class ConfiguratorTaskService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer une nouvelle tâche
     * Cette requête permet de créer une nouvelle tâche.&lt;br&gt;En cas de succès, la réponse contient un objet TaskDTO avec l&#39;identifiant de la tâche créée et un code 201 (Created).&lt;br&gt;Dans ce cas, la tâche créée aura une date de création qui sera égale à la date de l&#39;instant de la requête.&lt;br&gt;En cas d&#39;échec dû au fait que le DTO a déjà un identifiant, le code d&#39;erreur 400 (Bad Request) sera renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param taskDTO taskDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTaskUsingPOST(xDataStoreID: string, taskDTO: TaskDTO, observe?: 'body', reportProgress?: boolean): Observable<TaskDTO>;
    public createTaskUsingPOST(xDataStoreID: string, taskDTO: TaskDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskDTO>>;
    public createTaskUsingPOST(xDataStoreID: string, taskDTO: TaskDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskDTO>>;
    public createTaskUsingPOST(xDataStoreID: string, taskDTO: TaskDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTaskUsingPOST.');
        }

        if (taskDTO === null || taskDTO === undefined) {
            throw new Error('Required parameter taskDTO was null or undefined when calling createTaskUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TaskDTO>(`${this.basePath}/api/tasks`,
            taskDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Supprimer une tâche par son identifiant
     * Cette requête permet de supprimer une tâche par son identifiant.&lt;br&gt;En cas de succès, la réponse contient un code 204 (NO_CONTENT).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTaskUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTaskUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTaskUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTaskUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteTaskUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTaskUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/tasks/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Lister toutes les tâches
     * Cette requête permet de lister toutes les tâches.&lt;br&gt;En cas de succès, la réponse contient une liste d&#39;objets TaskDTO avec l&#39;identifiant de la tâche et un code 200 (OK).
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTasksUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TaskLiteDTO>>;
    public getAllTasksUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaskLiteDTO>>>;
    public getAllTasksUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaskLiteDTO>>>;
    public getAllTasksUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTasksUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TaskLiteDTO>>(`${this.basePath}/api/tasks`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Récupérer une tâche par son identifiant
     * Cette requête permet de récupérer une tâche par son identifiant.&lt;br&gt;En cas de succès, la réponse contient un objet TaskDTO avec l&#39;identifiant de la tâche et un code 200 (OK).&lt;br&gt;En cas d&#39;échec, si l&#39;identifiant ne correspond à aucune tâche, alors le code d&#39;erreur 404 (Not Found) sera renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTaskUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<TaskDTO>;
    public getTaskUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskDTO>>;
    public getTaskUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskDTO>>;
    public getTaskUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTaskUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTaskUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TaskDTO>(`${this.basePath}/api/tasks/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Lister toutes les tâches selon leur état
     * Cette requête permet de lister toutes les tâches selon leur état.&lt;br&gt;En cas de succès, la réponse contient une liste d&#39;objets TaskDTO avec l&#39;identifiant de la tâche et un code 200 (OK).&lt;br&gt;Les états possibles sont :&lt;br&gt;&lt;ul&gt;&lt;li&gt; + &lt;b&gt;in_progress&lt;/b&gt; : tâches en cours de traitement&lt;/li&gt;&lt;br&gt;&lt;li&gt; + &lt;b&gt;end&lt;/b&gt; : tâches terminées&lt;/li&gt;&lt;br&gt;&lt;li&gt; + &lt;b&gt;wait&lt;/b&gt; : tâches en attente&lt;/li&gt;&lt;br&gt;&lt;li&gt; + &lt;b&gt;error&lt;/b&gt; : tâches en erreur&lt;/li&gt;&lt;br&gt;&lt;li&gt; + &lt;b&gt;interrupted&lt;/b&gt; : tâches interrompues&lt;/li&gt;&lt;/ul&gt;
     * @param xDataStoreID X-DataStoreID
     * @param status status
     * @param type type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTasksUsingGET(xDataStoreID: string, status: Array<string>, type: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<TaskLiteDTO>>;
    public getTasksUsingGET(xDataStoreID: string, status: Array<string>, type: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaskLiteDTO>>>;
    public getTasksUsingGET(xDataStoreID: string, status: Array<string>, type: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaskLiteDTO>>>;
    public getTasksUsingGET(xDataStoreID: string, status: Array<string>, type: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTasksUsingGET.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling getTasksUsingGET.');
        }

        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getTasksUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status) {
            status.forEach((element) => {
                queryParameters = queryParameters.append('status', element as any);
            });
        }
        if (type) {
            type.forEach((element) => {
                queryParameters = queryParameters.append('type', element as any);
            });
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<TaskLiteDTO>>(`${this.basePath}/api/tasks/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Mettre à jour une tâche
     * Cette requête permet de mettre à jour une tâche.&lt;br&gt;En cas de succès, la réponse contient un objet TaskDTO avec l&#39;identifiant de la tâche mise à jour et un code 200 (OK).&lt;br&gt;En cas d&#39;échec, si le DTO est invalide, alors le code d&#39;erreur 400 (Bad Request) sera renvoyé.&lt;br&gt;En cas d&#39;échec, si le changement n&#39;a pas pu être effectué, alors le code d&#39;erreur 500 (Internal Server Error) sera renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param taskDTO taskDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTaskUsingPUT(xDataStoreID: string, taskDTO: TaskDTO, observe?: 'body', reportProgress?: boolean): Observable<TaskDTO>;
    public updateTaskUsingPUT(xDataStoreID: string, taskDTO: TaskDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskDTO>>;
    public updateTaskUsingPUT(xDataStoreID: string, taskDTO: TaskDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskDTO>>;
    public updateTaskUsingPUT(xDataStoreID: string, taskDTO: TaskDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTaskUsingPUT.');
        }

        if (taskDTO === null || taskDTO === undefined) {
            throw new Error('Required parameter taskDTO was null or undefined when calling updateTaskUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<TaskDTO>(`${this.basePath}/api/tasks`,
            taskDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Lister toutes les tâches selon le critère de filtre
     * Cette requête permet de lister toutes les tâches selon le filtre
     * @param body
     * @param xDataStoreID
     * @param page
     * @param size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findTasks(body: TaskFilterDTO, xDataStoreID: string, page: number, size: number, observe?: 'body', reportProgress?: boolean): Observable<PageTaskLiteDTO>;
    public findTasks(body: TaskFilterDTO, xDataStoreID: string, page: number, size: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageTaskLiteDTO>>;
    public findTasks(body: TaskFilterDTO, xDataStoreID: string, page: number, size: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageTaskLiteDTO>>;
    public findTasks(body: TaskFilterDTO, xDataStoreID: string, page: number, size: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling findTasks.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling findTasks.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling findTasks.');
        }

        if (size === null || size === undefined) {
            throw new Error('Required parameter size was null or undefined when calling findTasks.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PageTaskLiteDTO>('post', `${this.basePath}/api/tasks/searchv2`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Arrêter une tâche en cours par son identifiant
     * Cette requête permet d&#x27;arrêter une tâche en cours par son identifiant.&lt;br&gt;En cas de succès, la réponse contient un objet avec le statut de la demande et un code 200 (OK).&lt;br&gt;La tâche s&#x27;arrêtera après avoir terminé le traitement de la ligne en cours.&lt;br&gt;En cas d&#x27;échec, si la tâche n&#x27;existe pas ou n&#x27;est pas en cours, le code d&#x27;erreur 400 (Bad Request) sera renvoyé.
     * @param xDataStoreID 
     * @param taskId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stopTask(xDataStoreID: string, taskId: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public stopTask(xDataStoreID: string, taskId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public stopTask(xDataStoreID: string, taskId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public stopTask(xDataStoreID: string, taskId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling stopTask.');
        }

        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling stopTask.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<{ [key: string]: any; }>('post',`${this.basePath}/api/tasks/${encodeURIComponent(String(taskId))}/stop`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
